/**
 * Company identity: contact details, social links and SEO copy.
 * A social link only appears on the site when it has a value.
 * `whatsapp` and `phone` take a phone number (e.g. +9665XXXXXXXX).
 */
export const site = {
  email: '',
  phone: '+201067068698',
  whatsapp: '+201067068698',
  address: { en: '', ar: '' },
  socials: {
    linkedin: 'https://www.linkedin.com/in/omar-albayoumi/',
    instagram: '',
    x: '',
    facebook: '',
    tiktok: '',
    snapchat: '',
    youtube: '',
    behance: '',
  },
  seo: {
    description: {
      en: 'B-Code builds modern websites, Odoo ERP systems, and custom software for companies that need reliable technology and clear results.',
      ar: 'B-Code تبني مواقع إلكترونية حديثة وأنظمة أودو وحلولاً برمجية مخصصة للشركات التي تحتاج تقنية موثوقة ونتائج واضحة.',
    },
    keywords: {
      en: ['B-Code', 'web development', 'Odoo development', 'Odoo ERP', 'custom software', 'company website'],
      ar: ['B-Code', 'تطوير مواقع', 'تطوير أودو', 'أنظمة ERP', 'برمجيات مخصصة', 'شركة برمجيات'],
    },
  },
};
